import { type ComponentFactory, type StandardComponentProps, type ShouldUpdate, detectIsComponent } from '../component';
import { type SlotProps, type Prettify } from '../shared';

const $$memo = Symbol('memo');

const defaultShouldUpdate = (props: {}, nextProps: {}): boolean => {
  for (const key in nextProps) {
    if (key !== 'slot' && nextProps[key] !== props[key]) return true;
  }

  return false;
};

function memo<P extends object>(
  factory: ComponentFactory<P>,
  shouldUpdate: ShouldUpdate<P & SlotProps> = defaultShouldUpdate,
) {
  const memoized: ComponentFactory<P> = (props: P) => factory(props).inject(shouldUpdate, $$memo);

  memoized.displayName = factory.displayName;

  return memoized as ComponentFactory<Prettify<P & StandardComponentProps>>;
}

const detectIsMemo = (instance: unknown) => detectIsComponent(instance) && instance.token === $$memo;

export { memo, detectIsMemo };
